import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { RopeShovelService } from '../../rope-shovel.service';
import { MatDialog } from '@angular/material/dialog';import { ViewPhotoComponent } from '../view-photo/view-photo.component';
import { NotificationsService } from 'angular2-notifications';
import { MandatoryCompartTypePhotoModel } from '../../models/rope-shovel.model';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'mandatory-component-photo',
  templateUrl: './mandatory-component-photo.component.html',
  styleUrls: ['./mandatory-component-photo.component.scss'],
  animations: [
    trigger(
      'fadeIn', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          style({ opacity: 1 }),
          animate('500ms', style({ opacity: 0 }))
        ])
      ]
    )]
})
export class MandatoryComponentPhotoComponent implements OnInit {
  @Input() photoTitle: string = "Title";
  @Input() photoId: number = 0;
  @Input() inspectionId: number = 0;
  @Input() compartTypeId: number = 0;
  @Input() mandatoryImageId: number = 0;
  @Input() side: number = 1;
  photoData: string = "";
  @Input() photoDescription: string = "This is the photo description. ";
  constructor(private _sanitizer: DomSanitizer, private _service: RopeShovelService, public dialog: MatDialog,
    private _notify: NotificationsService) { }
  newPhoto: string;

  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }

  ngOnInit() {
    this.loadPhoto();
  }

  loadPhoto() {
    if (this.photoId != -1) {
      this._service.getMandatoryImagePhotoThumbnail(this.photoId).subscribe(r => {
        this.photoData = r.Photo;
      });
    }
  }
  private compressImage(src) {
    return new Promise((res, rej) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        const elem = document.createElement('canvas');

        let width, height;
        width = img.width;
        height = img.height;

        console.log('width', width)
        console.log('height', height)

        var ratio = height / width; //cal aspect ratio
        let imageWidth = 800;//643
        var new_height = imageWidth * ratio; //calculate new height


        elem.width = imageWidth;
        elem.height = new_height;
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, imageWidth, new_height);
        const data = ctx.canvas.toDataURL();
        res(data);
      }
      img.onerror = error => rej(error);
    })
  }
  
  // onSelectPhoto(event) {
  //   if (event.target.files && event.target.files[0]) {
  //     var reader = new FileReader();
  //     reader.readAsDataURL(event.target.files[0]); // read file as data url

  //     reader.onload = (event: FileReaderEvent) => { // called once readAsDataURL is completed
  //       this.newPhoto = event.target.result;


  //      // this.uploadPhoto(this.newPhoto);

  //       //resize photo
  //       this.compressImage(this.newPhoto).then((res: string) => {
  //         if (res) {
  //           this.uploadPhoto(res);
  //         }
  //       })
  //     }
  //   }
  // }
  onSelectPhoto(event: any) {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data URL
  
      reader.onload = (event: ProgressEvent<FileReader>) => { // called once readAsDataURL is completed
        if (event.target && event.target.result) {
          this.newPhoto = event.target.result as string; // Cast result to string
  
          // Resize photo
          this.compressImage(this.newPhoto).then((res: string) => {
            if (res) {
              this.uploadPhoto(res);
            }
          });
        }
      };
    }
  }
  

  viewPhoto() {
    let viewPhotoModalRef = this.dialog.open(ViewPhotoComponent, {
      width: '80%',
      height: '80%',
      data: { photoType: 'mandatory', photoId: this.photoId }
    });
    viewPhotoModalRef.afterClosed().subscribe(r => {
        if ((r.data != null) && (r.data.isDeleted)) {
            this.photoData = '';
        }
        else {
            this.loadPhoto();
        }
    });
  }

  uploadPhoto(p: string) {
    this._notify.info('Uploading', 'Uploading your photo now...');

    let uploadModel = new MandatoryCompartTypePhotoModel(this.inspectionId, this.mandatoryImageId, p, this.photoId, this.side);
    this._service.uploadCompartMandatoryPhoto(uploadModel).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Uploaded', r.m_Item2);
      } else {
        this._notify.error('Failed', r.m_Item2);
        console.log(r);
        this.newPhoto = '';
      }
    }, err => {
      this._notify.error('Failed', 'Unable to upload photo. Please contact TrackTreads support. ');
      console.log(err);
      this.newPhoto = '';
    });
  }
}

interface FileReaderEventTarget extends EventTarget {
  result: string
}

interface FileReaderEvent extends Event {
  target: FileReaderEventTarget;
  getMessage(): string;
}
